

const ProjectCardData = [
    
    {
        projectimage: "project1.png",
        title: "iBerry WiFi – Hotel Guest Wi-Fi Management Platform",
        text: "iBerry WiFi is a modern hotel guest Wi-Fi platform designed to deliver secure, high-speed, and branded internet access.",
        view: "https://iberry-wifi-react.vercel.app/"
    },
    {
        projectimage: "project2.png",
        title: "Cutshot Consulting",
        text: "Cutshot Consulting started off as a marketing agency that specialized in helping companies in the web3 space with their digital marketing efforts",
        view: "https://cutshot-i3l7s9be9-imchopra.vercel.app/"
    },
    {
        projectimage: "project3.png",
        title: "G1 FITNESS, THE WEBSITE FOR THE GYM",
        text: "Customers of the GYM can purchase memberships and gain access to meal plans through this website, which was created specifically for them..HTML, CSS, and JavaScript were used in its creation.",
        view: "https://imchopra.github.io/Fitness/"
    },

];

export default ProjectCardData;